import React, { ReactNode } from 'react';
import { ButtonClose } from '@lk-gtcom/ecomlab-components';
import FiltersSave from '../FiltersSave/FiltersSave';
import './FilterContainer.scss';

type FilterContainerProps = {
  children: ReactNode;
  onReset: (e: React.MouseEvent<HTMLButtonElement>) => void;
  loading: boolean
  saveFilters: () => void
  clearSavedFilters: () => void
  hasSavedFilters: boolean
};

const FilterContainer: React.FC<FilterContainerProps> = ({
  children,
  onReset,
  loading,
  saveFilters,
  clearSavedFilters,
  hasSavedFilters
}) => (
  <div className='filters-container'>
    {children}

    {saveFilters
      ?
      <FiltersSave
        loading={loading}
        saveFilters={saveFilters}
        clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
      />
      :
      null
    }

    <ButtonClose s onClick={onReset} />
  </div>
);

export { FilterContainer };